// extracted by mini-css-extract-plugin
module.exports = {"section":"Profile_section__2Q99h","profilecont":"Profile_profilecont__1yawf"};